import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.vorlagen-entity-types';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenVorlagenEntityTypesEffects {

    VorlagenEntityTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VORLAGEN_ENTITY_TYPES),
        mergeMap((x: ac.GetVorlagenEntityTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVorlagenEntityTypes().pipe(
                map((result: any) => {
                    return new ac.GetVorlagenEntityTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVorlagenEntityTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenTemplatesService);
        }
        return this.service;
    }
}
